import { createJumpErrorPage } from '@utiles/jumpErrorPage';

export let isServerEnv = typeof window === 'undefined';
//判断当前设置是否支持constant(safe-area-inset-top)或env(safe-area-inset-top)
let status = 0; // 0:还没数据，-1:不支持，1:支持

const ENTRY_PAGE_ALL_PARAMS = 'entryPageAllPArams';
let getHrefParamFromLocation = function (paramName, newHref) {
  let href = newHref || '';
  let search =
    (global.location && (global.location.search || global.location.hash)) || '';
  href = search.replace(/^\?/, '');
  let reg = new RegExp('(^|&|\\?)' + paramName + '=([^&]*)(&|$)');
  let matchResult = href.match(reg);
  let param = '';
  if (matchResult !== null && matchResult.length > 0) {
    try {
      param = decodeURIComponent(matchResult[2]);
    } catch {
      if (/\%/.test(matchResult[2])) {
        matchResult[2] = matchResult[2].replace(/\%/g, '$replace$');
        param = decodeURIComponent(matchResult[2]);
        param = param.replace(/\$replace\$/g, '%');
      } else {
        param = matchResult[2];
      }
    }
  }
  return param;
};

// 2021-07-23 大掌柜使用合作商域名部署，采用UId替代cookies
const UID_GAME_CONFIG = {
  215: {
    // host: 'events.gm99.com',
    host: 'dcq.sungame.vn',
    requestName: 'olgamevn.com'
  }
};

// 工单点击显示弹窗配置 (白名单)
export const feedbackPopupWhiteList = [
  // 游戏包体:packageName, 地区：zone, 设备：devicePlate, 语言：appLanguage
  {
    packageName: 'com.global.dzgjp',
    zone: 'ja-JP',
    devicePlate: 'android',
    appLanguage: 'ja-JP'
  }
];

export default {
  curentLang: '',
  query: null,
  route: null,
  isServerEnv: typeof window === 'undefined',
  global: typeof window === 'undefined' ? global : window,
  init() {
    this.initQuery();
    this.initLanguage();
  },
  initQuery() {
    if (this.rootVm && this.route) {
      this.query = this.route.query;
    }
  },

  setRoute(route) {
    this.route = route;
  },
  initLanguage() {
    if (this.query) {
      this.curentLang = this.query['language'];
    }
  },
  setRouterQuery(query) {
    this.query = query;
  },
  getQuery() {
    return this.query;
  },

  getHrefParam(paramName) {
    if (isServerEnv) {
      return this.getParamFromRouter(paramName);
    }
    return getHrefParamFromLocation(paramName);
  },
  getHrefParamUndecode(paramName) {
    return getHrefParamFromLocation(paramName);
  },
  getPageLangStorageKey() {
    const mainHostPrefix = this.getMainHost()?.split('.')[0];
    let langKey = '';
    if (mainHostPrefix) {
      langKey = mainHostPrefix + '_page_lang';
    } else {
      langKey = 'page_lang';
    }
    return langKey;
  },
  getLanguages() {
    let localStorageLang = '';
    if (
      localStorage &&
      typeof localStorage.getItem === 'function' &&
      localStorage.getItem(this.getPageLangStorageKey())
    ) {
      localStorageLang = localStorage
        .getItem(this.getPageLangStorageKey())
        .replace(/\"/g, '');
    }
    return (
      this.getHrefParam('appLanguage') ||
      this.getHrefParam('language') ||
      localStorageLang
    );
  },
  getMainHost() {
    if (this.isUidGame()) {
      let gameId =
        this.getHrefParam('gameId') ||
        this.getHrefParam('gameID') ||
        this.getHrefParam('game_id');
      return this.getUidGameRequestName(gameId);
    }
    if (window.location.hostname == 'localhost') {
      return '37games.com';
    }
    let hostArr = window.location.hostname.split('.');
    let mainArr = hostArr.slice(-2);
    return mainArr.join('.');
  },

  showWebLogo() {
    const mainHost = this.getMainHost();
    // 3syua.com 和  slfuntap.com 隐藏logo
    return ![atob('M3N5dWEuY29t'), atob('c2xmdW50YXAuY29t')].includes(mainHost);
  },

  getImageMainHost(gid) {
    let gameId = this.getHrefParam('gameId') || gid;
    let appLanguage = this.getLanguages();
    // 鬼語&越南語 顯示 100d
    if (+gameId === 125 && appLanguage === 'vi-VN') {
      return '100d';
      // 日理万机
    } else if (+gameId === 179) {
      return 'krsyua';
      // 泰越斗罗，越南语展示funtap，其他展示斗罗logo
    } else if (+gameId === 195) {
      const MAIN_HOST = this.getMainHost();
      return appLanguage === 'vi-VN' ? `${MAIN_HOST}_vi` : MAIN_HOST;
    } else {
      return this.getMainHost();
    }
  },

  getParamQuery() {
    let queryStr = '';
    if (isServerEnv || this.rootVm !== undefined) {
      queryStr = getHrefParamFromLocation(this.route.query);
    } else {
      let href = global.location.href;
      queryStr = href.replace(/.*(?=\?)/, '').replace(/\#(w*\/)*/, '');
    }
    return queryStr;
  },
  getCurrentHref() {
    let href = '';
    if (isServerEnv || this.rootVm !== undefined) {
      return href;
    } else {
      href = global.location.href;
    }
    return href;
  },

  getTimeZone() {
    let offset_GMT = new Date().getTimezoneOffset(); // 本地时间和格林威治的时间差，单位为分钟
    let offset_GMT_h = offset_GMT / 60;
    if (offset_GMT_h) {
      return `GMT${
        offset_GMT_h > 0 ? '-' + offset_GMT_h : '+' + offset_GMT_h * -1
      }`;
    } else {
      return 'GTM';
    }
  },

  setCookie(name, value, time) {
    let foreverTime = new Date();
    foreverTime.setFullYear(foreverTime.getFullYear() + 3000);
    document.cookie = `${name}=${value};domain=${this.getMainHost()};expires=${
      time || foreverTime.toGMTString()
    }`;
  },

  setCookieWithinDays(name, value, days) {
    let date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    let expires = '; expires=' + date.toUTCString();
    document.cookie =
      name + '=' + value + expires + `;domain=${this.getMainHost()};path=/`;
  },

  getCookie(name) {
    let arr,
      reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
    if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
    else return null;
  },

  getLocationSearch() {
    let search = '';
    if (isServerEnv || this.rootVm !== undefined) {
      return search;
    } else {
      search = global.location.search;
    }
    return search;
  },

  getLclStorageItem(name) {
    let res = null;
    if (
      typeof this.global.localStorage != 'undefined' &&
      this.global.localStorage &&
      typeof this.global.localStorage.getItem === 'function'
    ) {
      try {
        res = JSON.parse(this.global.localStorage.getItem(name));
        return res;
      } catch (e) {
        console.error(e);
      }
    }
    return res;
  },
  setLclStorageItem(name, val) {
    if (this.global.localStorage) {
      return this.global.localStorage.setItem(name, JSON.stringify(val));
    }
  },
  showMountedTime() {
    let startTime = parseInt(
      this.getHrefParam('timestamp') ||
        this.getHrefParam('timeStamp') ||
        this.getHrefParam('time_stamp')
    );
    let now = new Date().getTime();
    console.log('mountedTime: ');
    console.log(now - startTime);
  },
  storeEntryParams() {
    let storeParams = this.getAllWebviewEntryParams();
    if (storeParams != null) {
      return false;
    }
    let params = {
      Isdblink: this.getHrefParam('Isdblink'),
      advertise: this.getHrefParam('advertise'),
      androidid: this.getHrefParam('androidid'),
      appLanguage: this.getHrefParam('appLanguage'),
      apps: this.getHrefParam('apps'),
      battery: this.getHrefParam('battery'),
      channelId: this.getHrefParam('channelId'),
      country: this.getHrefParam('country'),
      cpOrderId: this.getHrefParam('cpOrderId'),
      cpProductId: this.getHrefParam('cpProductId'),
      customUserId: this.getHrefParam('customUserId'),
      deepLinkURL: this.getHrefParam('deepLinkURL'),
      devicePlate: this.getHrefParam('devicePlate'),
      gameId: this.getHrefParam('gameId'),
      gpid: this.getHrefParam('gpid'),
      sdkToken: this.getHrefParam('sdkToken'),
      imei: this.getHrefParam('imei'),
      isFirst: this.getHrefParam('isFirst'),
      language: this.getHrefParam('language'),
      loginAccount: this.getHrefParam('loginAccount'),
      loginSign: this.getHrefParam('loginSign'),
      loginTimestamp: this.getHrefParam('loginTimestamp'),
      loginUID: this.getHrefParam('loginUID'),
      mac: this.getHrefParam('mac'),
      netType: this.getHrefParam('netType'),
      osVersion: this.getHrefParam('osVersion'),
      packageName: this.getHrefParam('packageName'),
      packageVersion: this.getHrefParam('packageVersion'),
      phoneModel: this.getHrefParam('phoneModel'),
      productId: this.getHrefParam('productId'),
      ptCode: this.getHrefParam('ptCode'),
      publishPlatForm: this.getHrefParam('publishPlatForm'),
      ratio: this.getHrefParam('ratio'),
      remark: this.getHrefParam('remark'),
      roleId: this.getHrefParam('roleId'),
      roleLevel: this.getHrefParam('roleLevel'),
      roleName: this.getHrefParam('roleName'),
      sdkVersion: this.getHrefParam('sdkVersion'),
      serverId: this.getHrefParam('serverId'),
      thirdPlatForm: this.getHrefParam('thirdPlatForm'),
      timeStamp: this.getHrefParam('timeStamp'),
      timeZone: this.getHrefParam('timeZone'),
      ueAndroidId: this.getHrefParam('ueAndroidId'),
      userId: this.getHrefParam('userId'),
      userMode: this.getHrefParam('userMode'),
      userName: this.getHrefParam('userName'),
      zone: this.getHrefParam('zone')
    };
    sessionStorage.setItem(ENTRY_PAGE_ALL_PARAMS, JSON.stringify(params));
  },
  getAllWebviewEntryParams() {
    let params = {};
    try {
      params = JSON.parse(sessionStorage.getItem(ENTRY_PAGE_ALL_PARAMS)) || {};
    } catch (e) {}
    return params;
  },
  getHrefParamObj() {
    let paramsStr =
      window.location.search.substring(1) ||
      location.hash.replace(/^\#[\w\_\-]*\/\?*/, '');
    let res = {};
    let paramsArr = [];
    if (paramsStr.indexOf('&') >= 0) {
      paramsArr = paramsStr.split('&');
    } else if (paramsStr) {
      paramsArr = [paramsStr];
    }

    paramsArr.forEach(item => {
      let result = item.split('=');
      res[result[0]] = result[1];
    });

    return res;
  },
  getAllUrlParamsObj() {
    let hrefParams = {};
    try {
      let _u = new URL(window.location.href);
      [..._u.searchParams].forEach(item => {
        hrefParams[item[0]] = item[1];
      });
    } catch (error) {
      hrefParams = this.getHrefParamObj();
    }
    return hrefParams || {};
  },
  assignParamsObj(obj1, obj2) {
    let newObj1 = Object.assign({}, obj1);
    let newObj2 = Object.assign({}, obj2);
    return Object.assign(newObj1, newObj2);
  },
  objParamsToStrParams(obj) {
    let res = [];
    for (let key in obj) {
      res.push(`${key}=${obj[key]}`);
    }
    return res.join('&');
  },
  hrefAddParam(url, key, value) {
    let res = '';
    if (url && key && value) {
      // 先把vue链接后面的hash切割存一下
      let vueUrlArr = url.split('#/');
      let urlArr = vueUrlArr[0].split('?');
      // 判断是否有？，如果有，则用新的key值替换原来的，没有的话就直接加
      if (urlArr.length > 1 && urlArr[1]) {
        let reg = new RegExp('(^|&)' + key + '=[^&]*', 'g');
        let withoutKeyUrl = urlArr[1].replace(reg, '').replace(/^&/, '');
        res = `${urlArr[0]}?${withoutKeyUrl}${
          withoutKeyUrl ? '&' : ''
        }${key}=${value}`;
      } else {
        res = `${urlArr[0]}?${key}=${value}`;
      }
      // 如果是vue链接，就补上后面的hash
      if (vueUrlArr.length > 1 && vueUrlArr[1]) {
        res += '#/' + vueUrlArr[1];
      }
    }
    return res;
  },
  addEvenListener(callback, eventName) {
    let addEvenListener = window.addEventListener || window.attatchEvent;
    let messageEvent = window.addEventListener ? eventName : 'on' + eventName;
    addEvenListener(messageEvent, callback, false);
  },
  removeEventListener(callback, eventName) {
    let removeEvenListener = window.removeEventListener || window.detachEvent;
    let messageEvent = window.removeEventListener
      ? eventName
      : 'on' + eventName;
    removeEvenListener(messageEvent, callback, false);
  },
  getPlatformConfig() {
    let mainHost = window.btoa(this.getMainHost());
    let platformClassObj = {
      b21uaWthZGUuY29t: 'is-omni',
      'YmxhbmNvem9uZS5jb20=': 'is-blancozone'
    };
    let isOmni = mainHost === 'b21uaWthZGUuY29t';
    return { isOmni, platformClass: platformClassObj[mainHost] || false };
  },
  setVuePrototypePlatformConfig(Vue) {
    let platformConfigObj = this.getPlatformConfig();
    let keys = Object.keys(platformConfigObj);
    keys.forEach(key => {
      let prop = `$${key}`;
      Vue.prototype[prop] = platformConfigObj[key];
    });
  },
  setAppleTouchIcon() {
    let link = document.createElement('link');
    link.rel = 'apple-touch-icon';
    link.href = `//abres.octlib.com/apple-touch-icon.png`;
    document.head.append(link);
  },
  addMeta(attrName, attrValue, content) {
    const selector = `meta[${attrName}="${attrValue}"]`;
    // 检查是否已存在相同属性的 meta 标签
    const existingMeta = document.querySelector(selector);
    if (existingMeta) {
      existingMeta.setAttribute('content', content);
      return;
    }
    // 创建并配置 meta 标签
    const meta = document.createElement('meta');
    meta.setAttribute(attrName, attrValue);
    meta.setAttribute('content', content);
    // 更安全的 head 获取方式
    document.head?.appendChild(meta);
  },
  setPageTitleAndIco(title, ico, keywords = '', description = '') {
    try {
      document.head.querySelector('title').innerText = title;
      document.head.querySelector('#icon').href = ico;
      keywords && this.addMeta('name', 'keywords', keywords);
      description && this.addMeta('name', 'description', description);
    } catch {}
  },
  addAppleTouchIcon(iconPath, iconSizes, iconMedia) {
    try {
      const link = document.createElement('link');
      link.rel = 'apple-touch-icon';
      link.href = iconPath;
      if (iconSizes) {
        link.sizes = iconSizes;
      }
      if (iconMedia) {
        link.media = iconMedia;
      }
      document.getElementsByTagName('head')[0].appendChild(link);
    } catch {}
  },
  isUidGame() {
    let hostNameArr = ['events.gm99.com'];
    Object.keys(UID_GAME_CONFIG).forEach(key => {
      hostNameArr.push(UID_GAME_CONFIG[key].host);
    });
    if (!!~hostNameArr.indexOf(window.location.host)) {
      return true;
    }
  },
  getUidGameHost(gameId) {
    return UID_GAME_CONFIG[gameId] ? UID_GAME_CONFIG[gameId].host : '';
  },
  getUidGameRequestName(gameId) {
    return UID_GAME_CONFIG[gameId]
      ? UID_GAME_CONFIG[gameId].requestName
      : window.atob('MzdnYW1lcy5jb20=');
  },
  getUidGameId(host) {
    let res = '';
    for (let key in UID_GAME_CONFIG) {
      if (UID_GAME_CONFIG[key].host == host) {
        res = key;
        break;
      }
    }
    return res;
  },
  /**
   *
   * 横版判断当前设置是否支持constant(safe-area-inset-top)或env(safe-area-inset-top)；
   * 部分Android设备，可以认识safa-area-inset-top，但会将其识别为0
   * @returns {boolean} 当前设备是否支持安全距离
   */
  supportSafeAreaLandscape() {
    if (status !== 0) {
      // 缓存数据，只向 body 插入一次 dom 即可
      return status === 1;
    }
    const div = document.createElement('div');
    const id = 'test-check-safe-area';
    const styles = [
      'position: fixed',
      'z-index: -1',
      'width: constant(safe-area-inset-left)',
      'width: env(safe-area-inset-left)'
    ];
    div.style.cssText = styles.join(';');
    div.id = id;
    document.body.appendChild(div);
    const areaDiv = document.getElementById(id);
    if (areaDiv) {
      status = areaDiv.offsetWidth > 0 ? 1 : -1; // 该 div 的高度是否为 0
      if (areaDiv.parentNode) {
        areaDiv.parentNode.removeChild(areaDiv);
      }
    }
    return status === 1;
  },
  jumpErrorPage: createJumpErrorPage()
};
